import { Chip } from '@mui/material';
import { useCaseFieldData } from '../../../hooks/useCaseField';
import type { FieldMode } from '../../../hooks/useCaseField';

const OverrideReasonChip: React.FC<{ mode: FieldMode }> = ({ mode }) => {
  const data = useCaseFieldData(mode);

  if (!data.nurseOverrideReason) return null;

  return (
    <Chip
      label={`Override: ${data.nurseOverrideReason}`}
      size="small" color="warning" variant="outlined"
    />
  );
};

export default OverrideReasonChip;